import styled from '@emotion/styled';
import Cell from './Table.Cell';

const FootCell = styled(Cell)`
  border-top: 1px solid ${p => p.theme.colors.horizontalRule};
  background-color: ${p => p.theme.colors.tableFooter};
`;

export default FootCell;
